<template>
    <v-menu
        ref="menu"
        v-model="visible"
        :close-on-content-click="false"
        :return-value.sync="selectedDates"
        transition="scale-transition"
        offset-y
        min-width="auto"
    >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                v-model="selectedDates"
                :label="cf.label"
                prepend-icon="mdi-calendar"
                readonly
                v-bind="attrs"
                v-on="on"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="selectedDates"
            :active-picker.sync="activePicker"
            no-title
            scrollable
            :min="cf.min"
            :max="cf.max"
            :first-day-of-week="firstDayOfWeek"
            @change="submit"
        >
            <!-- <v-spacer></v-spacer>
                <v-btn text outlined color="pink" @click="visible = false">
                    Hủy
                </v-btn>
                <v-btn text outlined color="success" @click="submit">
                    Chọn
                </v-btn> -->
        </v-date-picker>
    </v-menu>
</template>

<script>
export default {
    name: "BotDatePicker",

    props: ["value", "options"],

    data() {
        return {
            cf: {
                label: "chọn ngày",
                min: null,
                max: null,
            },
            activePicker: null,
            firstDayOfWeek: 1,
            selectedDates: this.value,
            visible: false,
        };
    },

    watch: {
        visible(val) {
            if (val) setTimeout(() => (this.activePicker = "YEAR"));
        },
    },

    mounted() {
        if (!this.options) return;
        this.cf = Object.assign({}, this.options);
    },

    computed: {},

    methods: {
        submit() {
            this.$refs.menu.save(this.selectedDates);
            this.$emit("input", this.selectedDates);
        },
    },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus"></style>



// WEBPACK FOOTER //
// bot.date.picker.vue